"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Line = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var d3 = tslib_1.__importStar(require("d3"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Line = (function (_super) {
    tslib_1.__extends(Line, _super);
    function Line(props) {
        var _this = _super.call(this, props) || this;
        _this.createAttributes = _this.createAttributes.bind(_this);
        _this.Line = null;
        return _this;
    }
    Line.prototype.componentDidMount = function () {
        this.createAttributes();
    };
    Line.prototype.componentDidUpdate = function () {
        this.createAttributes();
    };
    Line.prototype.createAttributes = function () {
        var _a = this.props, xScale = _a.xScale, yScale = _a.yScale, color = _a.color, data = _a.data, crispEdges = _a.crispEdges, _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1 : _b, _c = _a.opacity, opacity = _c === void 0 ? 1 : _c, _d = _a.dashed, dashed = _d === void 0 ? false : _d, _e = _a.fill, fill = _e === void 0 ? 'none' : _e;
        var lineGenerator = d3
            .line()
            .x(function (d) { return (xScale ? xScale(d.x) : d.x); })
            .y(function (d) { return (yScale ? yScale(d.y) : d.y); });
        d3.select(this.Line)
            .datum(data)
            .attr('fill', fill)
            .attr('class', 'line')
            .attr('d', function (d) { return lineGenerator(d); })
            .attr('stroke-width', strokeWidth)
            .style('shape-rendering', crispEdges ? 'crispedges' : '')
            .attr('opacity', opacity)
            .attr('stroke', color)
            .attr('stroke-dasharray', dashed ? '2 4' : 'none')
            .attr('fill-rule', 'evenodd')
            .attr('stroke', color);
    };
    Line.prototype.render = function () {
        var _this = this;
        var _a = this.props, clipPath = _a.clipPath, _b = _a.mixBlendMode, mixBlendMode = _b === void 0 ? 'inherit' : _b;
        return (react_1.default.createElement(StyledLine, { mixBlendMode: mixBlendMode },
            react_1.default.createElement("path", { ref: function (el) { return (_this.Line = el); }, clipPath: clipPath })));
    };
    return Line;
}(react_1.Component));
exports.Line = Line;
Line.displayName = 'FOS_ChartLine';
var StyledLine = styled_components_1.default.g(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  mix-blend-mode: ", ";\n"], ["\n  mix-blend-mode: ", ";\n"])), function (_a) {
    var mixBlendMode = _a.mixBlendMode;
    return mixBlendMode;
});
var templateObject_1;
